export default function stateListeners(ctrl) {
	$(document).on('forgotPassword.emailForm', function () {
		ctrl.currentState = 'emailForm';
	});

	$(document).on('forgotPassword.reminderSent', function () {
		ctrl.currentState = 'reminderSent';
	});

	$(document).on('forgotPassword.errorSend', function () {
		ctrl.currentState = 'errorSend';
	});

	$(document).on('forgotPassword.tokenExpired', function () {
		ctrl.currentState = 'tokenExpired';
	});

	$(document).on('forgotPassword.successChange', function () {
		ctrl.currentState = 'successChange';
	});

	$(document).on('forgotPassword.passwordForm', function () {
		ctrl.formData = {};
		ctrl.currentState = 'passwordForm';
	});

	$(document).on('forgotPassword.passwordSMS', function () {
		if (!ctrl.userData) {
			ctrl.goToLoginPage('/login');
		} else {
			ctrl.currentState = 'passwordSMS';
		}
	});
}
